// CSS
import '../scss/index.scss';

// Polyfills
import './lib/polyfills';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/wl-share';

// Framework
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/anchor-scroll-to';
import './site/back-to-top';
import './site/card-favorite';
import './site/cook-mode';
import './site/countdown';
import './site/hp-form-select';
import './site/resources';
import './site/load-more';
import './site/mobile-nav';
import './site/poll';
import './site/search-autosuggest';
import './site/side-nav';
import './site/sub-nav';
import './site/parallax';
import './site/vendor-add-to-calendar-button';
import './site/recipe';
import './site/role-checkboxes';

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');
$('.mask-input-tactic input').mask('999999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false // Prevent page from jumping back to top
    }
  }
});

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  rows: 0,
  autoplay: false,
  dots: true,
  infinite: false,
  speed: 500,
  nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow-right"></i></button>`,
  prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow-left"></i></button>`
});

// Init single carousel
const carouselSingleMarquee = carousels('[data-carousel="single-marquee"]', {
  rows: 0,
  autoplay: false,
  dots: true,
  infinite: false,
  speed: 500,
  appendArrows: `.button-container`,
  appendDots: `.button-container`,
  nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow-right"></i></button>`,
  prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow-left"></i></button>`
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  rows: 0,
  autoplay: false,
  dots: false,
  infinite: false,
  speed: 300,
  nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow-right"></i></button>`,
  prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow-left"></i></button>`,
  slidesToShow: 3,
  slidesToScroll: 1,
  slide: 'article', // ignore modals for correct indexing
  variableWidth: true,
  responsive: [
    {
      breakpoint: 830,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 430,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Init multiple carousel
const carouselCards = carousels('[data-carousel="cards"]', {
  rows: 0,
  autoplay: false,
  dots: false,
  infinite: false,
  speed: 300,
  nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow-right"></i></button>`,
  prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow-left"></i></button>`,
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 830,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 430,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Init multiple carousel (circle)
const carouselMultipleCircle = carousels('[data-carousel="multiple-circle"]', {
  rows: 0,
  autoplay: false,
  dots: false,
  infinite: false,
  speed: 300,
  nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow-right"></i></button>`,
  prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow-left"></i></button>`,
  slidesToShow: 10,
  slidesToScroll: 1,
  variableWidth: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 8,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 840,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 350,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

// Init multiple carousel
const carouselMultipleEducation = carousels(
  '[data-carousel="multiple-education"]',
  {
    rows: 0,
    autoplay: false,
    dots: false,
    infinite: false,
    speed: 300,
    nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><i class="icon-arrow-right"></i></button>`,
    prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><i class="icon-arrow-left"></i></button>`,
    slidesToShow: 4,
    slidesToScroll: 1,
    slide: 'article',
    variableWidth: true,
    responsive: [
      {
        breakpoint: 830,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 430,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }
);

if ($('#recipe-search-form').length) {
  $('#select-cooking-methods').on('change', () => {
    $('#recipe-search-form').submit();
  });
}

$(document).ready(function () {
  setTimeout(() => {
    // remove AddToListBlock from html
    $('.whisk--app .AddToListBlock').remove();
  }, 5000);
});

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');
window.wlInitToggles = (scopeSelector = '') => {
  // if scopeSelector is passed, init only inside that scope (faster)
  const selector = scopeSelector
    ? `${scopeSelector} [data-toggle-target]`
    : '[data-toggle-target]';

  toggles(selector);
};

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');

if ($('.modal--video')) $('.modal--video').insertAfter('.site-footer');

function onYouTubePlayerStateChange(event) {
  const videoId = event.target.getVideoData().video_id;
  window.dataLayer = window.dataLayer || [];
  switch (event.data) {
    case YT.PlayerState.PLAYING:
      window.dataLayer.push({
        event: 'youtube_play',
        videoId: videoId
      });
      break;
    case YT.PlayerState.PAUSED:
      window.dataLayer.push({
        event: 'youtube_pause',
        videoId: videoId
      });
      break;
    case YT.PlayerState.ENDED:
      window.dataLayer.push({
        event: 'youtube_complete',
        videoId: videoId
      });
      break;
  }
}

if ($('[data-modal-show="beef-tv-modal"]').length) {
  if (!window.YT) {
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  $('[data-modal-show="beef-tv-modal"]').on('click', (event) => {
    let videoId = event.delegateTarget.getAttribute('data-video-id');
    let videosource = event.delegateTarget.getAttribute('data-video-source');
    // let src = event.target.src;
    // const srcset = event.target.srcset;

    // if (srcset) {
    //   // this seems more complicated than it needs to be...
    //   let entries = srcset.split(',').map((entry) => entry.trim());
    //   let match = entries.find((entry) => entry.endsWith('2x'));
    //   src = match ? match.split(' ')[0] : src;
    // }

    let is_vimeo = videosource === 'vimeo';
    let vimeo_url = 'https://player.vimeo.com/video/' + videoId;
    let youtube_url =
      'https://www.youtube.com/embed/' +
      videoId +
      '?feature=oembed&enablejsapi=1&origin=' +
      $(location).attr('origin');
    // NOTE: 5/12/25 - Removed SRCDOC functionality because it prevents GTM tracking (or at least makes it far more difficult).
    // Also, I don't think in this context that SRCDOC is really having significant performance benefits.
    // Leaving the code in here for future reference if we need to revisit performance.
    // let youtube_srcdoc = `
    //   <style>
    //     * { padding:0; margin:0; overflow:hidden; }
    //     html, body { height:100%; }
    //     img, span { position:absolute; width:100%; top:0; bottom:0; margin:auto; }
    //     span { height:1.5em; text-align:center; font:48px/1.5 sans-serif; color:white; text-shadow:0 0 0.5em black; }
    //   </style>
    //   <a href="https://www.youtube.com/embed/${videoId}?autoplay=1">
    //     <img src="https://img.youtube.com/vi/${videoId}/hqdefault.jpg" alt="YouTube video thumbnail">
    //     <span>▶</span>
    //   </a>
    // `;
    // let vimeo_srcdoc = `
    //   <style>
    //     * { padding:0; margin:0; overflow:hidden; }
    //     html, body { height:100%; }
    //     img, span { position:absolute; width:100%; height:100%; top:0; bottom:0; margin:auto; background-color:white; }
    //     span { height:1.5em; text-align:center; font:48px/1.5 sans-serif; color:white; text-shadow:0 0 0.5em black; }
    //   </style>
    //   <a href="https://player.vimeo.com/video/${videoId}?autoplay=1">
    //     <img src="${src}" alt="Vimeo video thumbnail">
    //     <span style="background-color:transparent;">▶</span>
    //   </a>
    // `;

    const iframe = $('<iframe>', {
      width: '100%',
      height: '100%',
      loading: 'lazy',
      title: (is_vimeo ? 'Vimeo' : 'YouTube') + ' video player',
      frameborder: 0,
      allow:
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
      allowfullscreen: true,
      src: is_vimeo ? vimeo_url : youtube_url
    });

    // if (is_vimeo) {
    //   iframe.attr('srcdoc', vimeo_srcdoc);
    // }

    $('#beef-tv-modal .u--embed-responsive').append(iframe);

    if (is_vimeo) {
      let isVimeoAPILoaded = typeof Vimeo !== 'undefined';

      if (!isVimeoAPILoaded) {
        const vimeoScript = document.createElement('script');
        vimeoScript.src = 'https://player.vimeo.com/api/player.js';
        vimeoScript.onload = initializeVimeoPlayer;
        document.head.appendChild(vimeoScript);
        isVimeoAPILoaded = true;
      } else {
        initializeVimeoPlayer();
      }

      function initializeVimeoPlayer() {
        const vimeoPlayer = $('#beef-tv-modal .u--embed-responsive iframe');
        const player = new Vimeo.Player(vimeoPlayer);

        player.on('play', () => {
          player.getVideoTitle().then((title) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'video',
              video_action: 'play',
              video_url: vimeo_url,
              video_percent: 0,
              video_title: title
            });
          });
        });

        player.on('pause', () => {
          player.getCurrentTime().then((currentTime) => {
            player.getDuration().then((duration) => {
              const percent = Math.round((currentTime / duration) * 100);
              player.getVideoTitle().then((title) => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'video',
                  video_action: 'pause',
                  video_url: vimeo_url,
                  video_percent: percent,
                  video_title: title
                });
              });
            });
          });
        });

        player.on('timeupdate', (data) => {
          const percent = Math.round(data.percent * 100);
          player.getVideoTitle().then((title) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'video',
              video_action: 'progress',
              video_url: vimeo_url,
              video_percent: percent,
              video_title: title
            });
          });
        });
      }
    }

    // if (!is_vimeo) {
    //   setTimeout(() => {
    //     const player = new YT.Player(iframe[0], {
    //       events: {
    //         onStateChange: onYouTubePlayerStateChange
    //       }
    //     });

    //     window.dataLayer = window.dataLayer || [];
    //     window.dataLayer.push({
    //       event: 'wlYouTubeIframeLoaded',
    //       videoId: videoId
    //     });
    //   }, 500);
    // } else {
    //   window.dataLayer = window.dataLayer || [];
    //   window.dataLayer.push({ event: 'wlVimeoIframeLoaded', videoId: videoId });
    // }
  });

  $('[data-modal="beef-tv-modal"]').on('modal:afterHide', (event) => {
    $('#beef-tv-modal .u--embed-responsive').empty();
  });
}

// After page is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  // Check if div with left-display__image-background class exists
  if ($('.left-display__image-background').length) {
    // foreach span within div replace the background image with the data-src attribute
    $('.left-display__image-background span').each(function () {
      $(this).css('background-image', 'url(' + $(this).data('src') + ')');
    });
  }
});

// GTM custom dataLayer events - tracking clicks
// add a class of 'wlTrackClick' to any element you want to track
// ensure data-wl-event and data-wl-label attributes are set
document.querySelectorAll('.wlTrackClick').forEach((button) => {
  window.dataLayer = window.dataLayer || [];

  button.addEventListener('click', function (event) {
    let destinationUrl = this.getAttribute('href');
    destinationUrl =
      'https://www.addtoany.com/share' !== destinationUrl
        ? null
        : destinationUrl;

    if (destinationUrl) {
      event.preventDefault();
    }

    const eventName = this.getAttribute('data-wl-event') || 'eventNameNotSet';
    const eventLabel = this.getAttribute('data-wl-label') || 'eventLabelNotSet';

    window.dataLayer.push({
      event: eventName,
      eventLabel: eventLabel,
      timestamp: new Date().toISOString()
    });

    if (destinationUrl) {
      setTimeout(() => {
        window.location.href = destinationUrl;
      }, 500);
    }
  });
});
